import { render, staticRenderFns } from "./SwiperResponsive.vue?vue&type=template&id=7c7460c2&"
import script from "./SwiperResponsive.vue?vue&type=script&lang=js&"
export * from "./SwiperResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports